import * as WorkerApi from 'saas/users/api';
import * as SiteApi from 'saas/sites/api';
import * as ProductApi from 'saas/products/api';
import * as RefApi from 'saas/references/api';
import * as ContactApi from 'saas/contacts/api';
import { Set } from 'immutable';
import { getIsFetching } from '../reducers/requirements';
import { fetchSites } from './sites';
import { TASK_TYPE } from 'saas/constants';
import {
  QUANTITY_UNIT,
  TECH_EPI,
  INVENTORY_TO_PLAN,
} from 'saas/references/constants';

export const FETCH_REQUIREMENTS = 'case.FETCH_REQUIREMENTS';
export const FETCH_REQUIREMENTS_SUCCESS = 'case.FETCH_REQUIREMENTS_SUCCESS';
export const FETCH_CONTACTS = 'case.FETCH_CONTACTS';
export const FETCH_CONTACTS_SUCCESS = 'case.FETCH_CONTACTS_SUCCESS';

const requestRequirements = () => ({
  type: FETCH_REQUIREMENTS,
});

const receiveRequirements = ({
  isNew,
  workers,
  sites,
  products,
  units,
  securityEpis,
  inventoryToPlan,
  contacts,
}) => ({
  type: FETCH_REQUIREMENTS_SUCCESS,
  isNew,
  workers,
  sites,
  products,
  units,
  securityEpis,
  inventoryToPlan,
  contacts,
});

const requestContacts = () => ({
  type: FETCH_CONTACTS,
});

const receiveContacts = contacts => ({
  type: FETCH_CONTACTS_SUCCESS,
  contacts,
});

const fetchProducts = () => {
  const mapWithType = (type, products) =>
    products.map(p => ({
      ...p,
      type,
    }));

  const getByTask = task => {
    return ProductApi.getToolChoicesByTask(task).then(products =>
      mapWithType(task, products)
    );
  };

  const groupByTask = products =>
    Set(products)
      .groupBy(p => p.type)
      .toMap();

  return Promise.all([
    getByTask(TASK_TYPE.RAT),
    getByTask(TASK_TYPE.INSECT),
    //getByTask(TASK_TYPE.DISINFECTION),
    getByTask(TASK_TYPE.OTHER_PESTS),
    getByTask(TASK_TYPE.ANNEX1),
    getByTask(TASK_TYPE.ANNEX2),
  ]).then(res =>
    groupByTask(
      res[0]
        .concat(res[1])
        .concat(res[2])
        .concat(res[3])
        .concat(res[4])
    )
  );
};

export const fetchRequirements = (customer, siteCase, isNew) => (
  dispatch,
  getState
) => {
  if (getIsFetching(getState())) {
    return Promise.resolve();
  }

  dispatch(requestRequirements);

  const doFetch = () =>
    Promise.all([
      WorkerApi.getAllWorkers(),
      SiteApi.getByCustomer(customer),
      fetchProducts(),
      RefApi.getReferencesByType(QUANTITY_UNIT, siteCase),
      RefApi.getReferencesByType(TECH_EPI, siteCase),
      RefApi.getReferencesByType(INVENTORY_TO_PLAN, siteCase),
      ContactApi.getByCustomer(customer),
    ]);

  // Fetching requirements and planning
  const promise = doFetch().then(response =>
    dispatch(
      receiveRequirements({
        isNew,
        workers: response[0],
        sites: response[1],
        products: response[2],
        units: response[3],
        securityEpis: response[4],
        inventoryToPlan: response[5],
        contacts: response[6],
      })
    )
  );

  if (siteCase) {
    return promise.then(_ => dispatch(fetchSites(siteCase)));
  }

  return promise;
};

export const fetchContacts = customer => (dispatch, getState) => {
  dispatch(requestContacts());

  return ContactApi.getByCustomer(customer).then(res =>
    dispatch(receiveContacts(res))
  );
};



// WEBPACK FOOTER //
// ./src/modules/saas/pco/cases/form/actions/requirements.js